import React from 'react';
import { getBarColor } from '../../util/util';

interface AssessmentScoreBarProps {
  /** The percentage value to display, from 0 to 100. */
  value: number;
}

/**
 * A small component to display a progress bar and a percentage value,
 * suitable for embedding within a table cell.
 */
const AssessmentScoreBar: React.FC<AssessmentScoreBarProps> = ({ value }) => {
  // Ensure the value is clamped between 0 and 100
  const clampedValue = Math.max(0, Math.min(100, value));

  const barColor = getBarColor(clampedValue);

  return (
    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      <div
        style={{
          flexGrow: 1,
          height: '8px',
          backgroundColor: '#e5e7eb', // gray-200
          borderRadius: '9999px',
          overflow: 'hidden',
          marginRight: '8px',
        }}
      >
        <div
          style={{
            width: `${clampedValue}%`,
            height: '100%',
            backgroundColor: barColor,
            borderRadius: '9999px',
            transition: 'width 0.5s ease-in-out',
          }}
        />
      </div>
      <span
        style={{ minWidth: '40px', textAlign: 'right', fontSize: '0.875rem' }}
      >
        {`${Math.round(clampedValue)}%`}
      </span>
    </div>
  );
};

export default AssessmentScoreBar;
